<template>
  <div v-if="sshKey === ''" class="ssh-key-box">
    <div class="ssh-key">{{ $t('Integrations_Text_SshKeyNotAvailable') }}</div>
  </div>
  <div v-else class="ssh-key-box">
    <transition name="bounce" mode="out-in">
      <div class="ssh-key" v-if="showAnimation" key="regular" ref="sshKey">
        <el-input type="textarea" :rows="5" v-model="sshKey" />
      </div>
      <div class="ssh-key" v-else key="copied" ref="sshKey">
        <el-input type="textarea" :rows="5" v-model="sshKey" />
      </div>
    </transition>
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('Integrations_Message_SshKeyCopied')"
      placement="top"
      :manual="true"
      v-model="showTooltip"
    >
      <span
        @click="copySshKey"
        class="ssh-key-icon el-icon-copy-document"
      ></span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'IntegrationKeyBox',

  props: {
    sshKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showAnimation: true,
      showTooltip: false
    }
  },

  methods: {
    copySshKey() {
      this.showAnimation = !this.showAnimation
      this.selectText(this.$refs.sshKey)
      document.execCommand('copy')
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 2000)
    },

    selectText(element) {
      var range
      if (document.selection) {
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
    }
  }
}
</script>

<style scoped>
.ssh-key {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #333333;
  margin-bottom: 10px;
  width: 100%;
}

.ssh-key-box {
  display: flex;
}

.ssh-key-icon {
  font-size: 20px;
  margin-left: 10px;
  color: #333333;
  margin-top: 5px;
  transition: all 0.2s;
  font-weight: 600;
}

.ssh-key-icon:hover {
  color: #808080;
  transform: scale(1.1);
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationKeyBox.vue